












































import Vue from 'vue';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import UserMixin from '@/mixins/UserMixin';
import { Action } from 'vuex-class';

import PimcoreIntrospectionMixin from '@/mixins/PimcoreIntrospectionMixin';
import { like, and, or } from '@/classes/pimcore-filtering/Filters';
import EntitySchemaConstructor from '@/classes/schema-constructors/EntitySchemaConstructor';
import GraphQLFieldsExtractor from '@/classes/graphql-introspection/GraphQLFieldsExtractor';
import SystemFieldsExcluder from '@/classes/graphql-introspection/PimcoreSystemFieldsExcluder';
import gql from 'graphql-tag';

@Component
export default class MainHeader extends Mixins(PimcoreIntrospectionMixin, UserMixin) {
  roles: Array<any> = [];

  selectedRole: any = null;

  @Action('setTempRole', { namespace: 'profile' }) setTempRoleAction: any;

  async beforeMount() {
    await this.init();
  }

  async init() {
    this.roles = await this.loadRoles();
    if (this.pimcoreUser?.role?.role_type) {
      this.selectedRole = this.roles.find((v) => v.role_type === this.pimcoreUser.role.role_type);
    }
  }

  roleChanged(role: any) {
    this.setTempRoleAction(role);
  }

  setTheme(theme: string) {
    if (theme === 'dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
  }

  get isDark() {
    return this.$vuetify.theme.dark === true;
  }

  async loadRoles() {
    const fieldsExcluder = new SystemFieldsExcluder();
    const fieldsExtractor = new GraphQLFieldsExtractor(fieldsExcluder);
    const coordinatorIntrospection = await this.graphQLIntrospectionModule.getPimcoreIntrospection('Role');
    const coordinatorSchemaConstructor = new EntitySchemaConstructor(coordinatorIntrospection!, fieldsExtractor);
    const listingSchema = coordinatorSchemaConstructor.constructListingSchema();

    const users = await this.$apollo.query({
      query: gql`${listingSchema}`,
    });
    return users.data?.getRoleListing?.items?.map(
      ({ node }: any) => node
    );
  }
}
